
import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import {
	getSearchDate,
	nextDay
} from "@/utils"

@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate
	}
})
export default class TimeStatistical extends Vue {
	@Model('change') seltype!: number;
	@Prop({}) timevalue!: any;
	@Prop({
		default: () => {
			return  [
				{ value: 1, label: '自然日', type: 'date', format: 'yyyy-MM-dd', valueformat: 'yyyy-MM-dd' },
				{ value: 2, label: '自然周', type: 'week', format: 'yyyy 第 WW 周', valueformat: 'yyyy-MM-dd' },
				{ value: 3, label: '自然月', type: 'month', format: 'yyyy-MM', valueformat: 'yyyy-MM' },
				{ value: 4, label: '近7天', type: 'daterange', format: 'yyyy-MM-dd', valueformat: 'yyyy-MM-dd' },
				{ value: 5, label: '近30天', type: 'daterange', format: 'yyyy-MM-dd', valueformat: 'yyyy-MM-dd' },
			]
		}
	}) timeTypes!: any;
	private typelist = [];
	private type = 1
	private timetype = 'date'
	private format = 'yyyy-MM-dd'
	private valueformat = 'yyyy-MM-dd'
	private time: any = null
	private arrtime: any = []
	private options: any = {
		firstDayOfWeek: 1,
		disabledDate: (v) => {
			return v.getTime() > new Date().getTime()
		}
	}
	private optionsmonth: any = {
		firstDayOfWeek: 1,
		disabledDate: (v) => {
			return v.getTime() >= new Date(getSearchDate(1, false, -1)[0]).getTime()
		}
	}

	@Watch('seltype')
	private gettype(val) {
		this.type = this.seltype
	}
	@Watch('timevalue')
	private gettime(val) {
		if ([1, 2, 3].includes(this.seltype)) {
			this.time = val[0]
			this.arrtime = []
		} else {
			this.time = null
			this.arrtime = val
			let msg = this.typelist.find(v => v.value == this.type)
			this.timetype = msg.type
			this.format = msg.format
			this.valueformat = msg.valueformat
		}
	}
	@Watch('timeTypes')
	private timeTypesChange(val) {
		this.typelist = val;
		this.changetype(1)
	}

	private mounted(){
		console.log(this.timeTypes)
		this.typelist = this.timeTypes;
		this.changetype(1)
	}

	private changetype(e) {
		console.log(e)
		let msg = this.typelist.find(v => v.value == e)
		this.timetype = msg.type
		this.format = msg.format
		this.valueformat = msg.valueformat
		this.getchangetime(e)
	}
	//选择type后初始化日期
	private getchangetime(e: any) {
		if (e == 1) {
			this.time = getSearchDate(2)[0]
		} else if (e == 2) {
			this.time = getSearchDate(2)[0]
			// console.log(this.time,11)
		} else if (e == 3) {
			// console.log(getSearchDate(2)[0])
			this.time = getSearchDate(2)[0].substring(0, 7)
		} else if (e == 4) {
			this.time = null
			this.arrtime = [getSearchDate(2, false, -7)[0], getSearchDate(2, false, -1)[0]]
		} else if (e == 5) {
			this.time = null
			this.arrtime = [getSearchDate(2, false, -30)[0], getSearchDate(2, false, -1)[0]]
		}
		this.returnouter()
	}
	//返回
	private returnouter() {
		let returndate: any = []
		if (this.type == 1) {
			returndate = [this.time, this.time]
		} else if (this.type == 2) {
			let weekday = [7, 1, 2, 3, 4, 5, 6][new Date(this.time).getDay()]
			let today = new Date();
			let todayTime = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			//如果是星期一
			if (weekday == 1) {
				//-6随便减一天 取到上星期就好了 -7的话会一直循环溢出
				this.time = getSearchDate(2, false, -6)[0]
				this.returnouter()
				return
			}
			let startday = new Date(new Date(this.time).getTime() - 1000 * 60 * 60 * 24 * (weekday - 1))
			let endday = new Date(new Date(this.time).getTime() - 1000 * 60 * 60 * 24 * (weekday - 1) + 1000 * 60 * 60 * 24 * 6)

			if (endday.getTime() >= todayTime.getTime()) {
				endday = new Date(todayTime.getTime() - 1000 * 60 * 60 * 24);
			}
			// console.log(weekday,this.time)
			returndate = [this.formattime(startday, 1), this.formattime(endday, 1)]
			console.log(returndate)
		} else if (this.type == 3) {
			//如果是每月一号 随便减一天取上个月 一号的话选的时候应该被禁用了不让选 
			// console.log(nextDay(getSearchDate(1)[0],-1))
			// console.log(new Date(this.time+'-01').getTime()==new Date(getSearchDate(1)[1]).getTime())
			if (new Date(this.time + '-01').getTime() == new Date(getSearchDate(1)[1]).getTime()) {
				// console.log(1,getSearchDate(1))
				this.time = getSearchDate(2, false, -2)[0]
				this.returnouter()
				return
			}
			// console.log(this.time)
			// returndate = [this.formattime(this.time,3)+'-01',this.formattime(this.time,2)]
			//如果是当月一号 两个值都是一号 否则结束日期是当天的前一天
			// if(new Date(this.formattime(this.time,3)+'-01').getTime()!=new Date(this.formattime(this.time,2)).getTime()){
			//   returndate = [this.formattime(this.time,3)+'-01',nextDay(this.formattime(this.time,2),-1)]
			// }
			// if(Number(new Date().getDate())!=1){}
			// if(big.some(v=>v==Number(this.formattime(this.time,2).substring(5,7)))){
			//   returndate = [this.formattime(this.time,3)+'-01',this.formattime(this.time,2)]
			// }

			let big = [1, 3, 5, 7, 8, 10, 12]
			let middle = [4, 6, 9, 11]
			let min = [2]
			let month = (this.time.substring(5, 7))
			let day = new Date().getDate()
			let year = new Date(this.time).getFullYear()
			if (big.some(v => v == month)) {
				returndate = [`${year}-${month}-01`, `${year}-${month}-31`]
			} else if (middle.some(v => v == month)) {
				returndate = [`${year}-${month}-01`, `${year}-${month}-30`]
			} else if (min.some(v => v == month)) {
				if (year % 4 == 0) {
					returndate = [`${year}-${month}-01`, `${year}-${month}-29`]
				} else {
					returndate = [`${year}-${month}-01`, `${year}-${month}-28`]
				}
			}
			if ((new Date(nextDay(returndate[1], 1)).getTime() - 1) > new Date().getTime()) {
				let endtime = getSearchDate(2, false)[1]
				if (Number(getSearchDate(2, false)[1].substring(8, 10)) != 1) {
					endtime = nextDay(endtime, -1)
				}
				// console.log(getSearchDate(2,false)[1])
				returndate[1] = endtime
			}
			// console.log()
			// console.log(returndate,this.time,month)
		} else if (this.type == 4 || this.type == 5) {
			returndate = this.arrtime
		}
		if (this.type == 2 || this.type == 3) {
			// console.log(returndate,77)
		}
		this.$emit('gettime', {
			type: this.type,
			time: returndate
		})
	}
	private changetime(e) {
		this.returnouter()
	}
	private formattime(time: any, type: number) {
		if (!time) return ''
		let date = new Date(time)
		if (type == 2) {
			//如果是具体到日 只+28天 
			date = new Date(date.getTime() + 1000 * 60 * 60 * 24 * 32)
		}
		let year = date.getFullYear()
		let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
		let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
		let value = [year, month, day].join('-')
		if (type == 2) {
			value = nextDay([year, month, '01'].join('-'), -1)
		} else if (type == 3) {
			value = [year, month].join('-')
		}
		//如果查询结束日期大于今天 那么取昨天为最后一天
		// if(new Date(value).getTime()>new Date().getTime()){
		//   value = getSearchDate(2,false,-1)[0]
		//   console.log(value)
		// }
		return value
	}
	private getfocus() {
		this.$nextTick(() => {
			// console.log(this.$refs.datepicker.focus)
			// this.$refs.datepicker.focus()
		})
	}
}
